import React, { useState, useEffect, useRef } from 'react';

import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import './PhotoCrop.css';

import { SetModalState, RegisterModalData, RegisterModalObserver } from 'interface/PopUp.js';

import { Svg_Close } from 'components/Svg';

export default function PopUp_PhotoCrop(){

    const positionImg = useRef();
    
    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);
    const [ typeCrop, setTypeCrop ]   = useState(3);

    const [ proportionX, setProportionX ] = useState(9);
    const [ proportionY, setProportionY ] = useState(16);

    const [ crop, setCrop ] = useState({
        unit: '%', // Can be 'px' or '%'
        aspect: proportionX / proportionY,
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });

    async function cropImageNow (){
        modalData.RegisterCropData(
            { 
                "type" : modalData.type,
                "index" : modalData.index,
                "file" : modalData.file, 
                "showImg" : modalData.showImg, 
                "positionX" : crop.x, 
                "positionY" : crop.y, 
                "width" : crop.width, 
                "height" : crop.height,
                "showWidth" : positionImg.current.clientWidth,
                "widthReal" : positionImg.current.naturalWidth
            }
        );        
        SetModalState('PhotoCrop', false);
    };
 
    function onImageLoad(e) {
        const { naturalWidth: width, naturalHeight: height } = e.currentTarget;
        let crop = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 90,
                }
            ),
            width,
            height
        )  
        setCrop(crop);
    }

    function ClosePopUp(){
        SetModalState('PhotoCrop', false);
    }

    useEffect(()=>{
        RegisterModalData('PhotoCrop', setModaldata);
        RegisterModalObserver('PhotoCrop', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(showPopUp == true){
            setProportionX(modalData.proportionX);
            setProportionY(modalData.proportionY);
        }
    }, [showPopUp]);

    return (
        (showPopUp ? 
            <div className="PopUp">
                <div className="all photo_crop">
                    <div className="div_data type_div">
                        <div className="title">Recorte de foto</div>
                        <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                            <Svg_Close color="#F00000" className="icons" />
                        </div>
                    </div>
                    <div className="div_data" style={ { paddingTop: 0 } }>
                        <div className="content">
                            {
                                crop.width > 0 ? 
                                <div className="new_block_text btn_save" onClick={ ()=>{ cropImageNow() } }>Salvar</div> :
                                <div className="new_block_text">É necessário recortar a imagem para salvar</div>
                            }
                            <div className="">Clique na imagem e arrasta para realizar o recorte</div>
                            <div className="image_crop">
                                <ReactCrop crop={ crop } onChange={ setCrop } aspect={ proportionX / proportionY }>
                                    <img ref={ positionImg } src={ modalData.showImg } onLoad={ onImageLoad } className="image" />
                                </ReactCrop>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        : <React.Fragment></React.Fragment>)
    );
}